import { dataHooks } from '../../../../libs/dataHooks';

export const headerMenuDataHooks = dataHooks<{
  categoriesMenu: { expanded: boolean; categoryGroupName: string };
}>('header');
